import Giveaway, { IGiveaway } from './Giveaway';

interface IGiveaways {
  giveaways: IGiveaway[];
  remaining_giveaways_count: number;
  redeemed_giveaways_count: number;
  orders_to_next_giveaway: number;
}

class Giveaways implements IGiveaways {
  giveaways: Giveaway[];
  remaining_giveaways_count: number;
  redeemed_giveaways_count: number;
  orders_to_next_giveaway: number;

  constructor(attributes: IGiveaways) {
    Object.assign(this, attributes);

    this.giveaways = this.giveaways.map((giveaway) => (
      new Giveaway(giveaway)
    ));
  }
}

export { IGiveaways };
export default Giveaways;
